export default {"src":"/_next/static/image/public/images/edit_success_ack.db79e37d4b5ed5f7dd58853dad464212.svg","height":192,"width":145};